import React from "react";
import Banner from "../layout/Banner";

export default function AuthShell({
    eyebrow = "Secure access",
    title,
    description,
    children,
    footer,
    status = "default",
    align = "left",
}) {
    const isCentered = align === "center";
    const eyebrowTone =
        status === "warning"
            ? "text-amber-700"
            : status === "error"
                ? "text-red-700"
                : "text-primary";

    return (
        <main className="min-h-screen bg-surface flex items-center justify-center px-4 py-8">
            <section
                className={`bg-white shadow-card rounded-[32px] min-h-[520px] px-6 py-8 md:px-8 md:py-10 w-full max-w-xl animate-fadeIn ${
                    isCentered ? "text-center" : ""
                }`}
                aria-labelledby="auth-page-title"
            >
                <Banner />

                <div className={`${isCentered ? "items-center" : "items-start"} flex flex-col mt-4`}>
                    <p className={`text-xs font-semibold uppercase tracking-[0.2em] ${eyebrowTone}`}>{eyebrow}</p>
                    <h1 id="auth-page-title" className="mt-3 text-3xl font-semibold text-foreground">
                        {title}
                    </h1>
                    {description ? (
                        <p className={`mt-4 text-sm leading-6 text-secondary ${isCentered ? "max-w-lg mx-auto" : ""}`}>
                            {description}
                        </p>
                    ) : null}
                </div>

                <div className="mt-8">{children}</div>

                {footer ? <div className="mt-8 border-t border-lightBorder pt-5">{footer}</div> : null}
            </section>
        </main>
    );
}
